import { render, staticRenderFns } from "./CoinInfo.vue?vue&type=template&id=2732d1f8&scoped=true"
import script from "./CoinInfo.vue?vue&type=script&lang=js"
export * from "./CoinInfo.vue?vue&type=script&lang=js"
import style0 from "./CoinInfo.vue?vue&type=style&index=0&id=2732d1f8&prod&scoped=true&lang=scss"
import style1 from "./CoinInfo.vue?vue&type=style&index=1&id=2732d1f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2732d1f8",
  null
  
)

export default component.exports